import PropTypes, { string } from 'prop-types'
import React, { Component } from 'react'

import { CustomDateInput } from './CustomDateInput'
import { DatePickerInput } from './DatePickerInput'
import { WRAPPER_CLASS_NAME } from './DatePickerUtils'

class ASingleDatePicker extends Component {
  constructor(props) {
    super(props)

    this.state = {
      date: props.date,
    }
  }

  componentDidUpdate(prevProps) {
    const { date } = this.props

    if (prevProps.date === date || +prevProps.date === +date) return

    this.setState({
      date,
    })
  }

  onDateChange = (date) => {
    const { onChange } = this.props
    this.setState({ date })

    onChange?.(date)
  }

  render() {
    const {
      withFullScreenPortal,
      cmpRef,
      minDate,
      maxDate,
      className = '',
      placeholder,
      screenReaderInputMessage,
      showClearDate,
    } = this.props

    const { date } = this.state

    return (
      <div className={WRAPPER_CLASS_NAME}>
        <DatePickerInput
          screenReaderInputMessage={screenReaderInputMessage}
          showClearDate={showClearDate}
          renderCustomInput={(props) => (
            <CustomDateInput
              screenReaderInputMessage={screenReaderInputMessage}
              showClearDate={showClearDate}
              resetDate={() => {
                this.onDateChange(null)
              }}
              {...props}
            />
          )}
          withPortal={withFullScreenPortal}
          placeholder={placeholder}
          className={`ra-date-picker ${className}`}
          id={cmpRef}
          date={date}
          onSelect={this.onDateChange}
          minDate={minDate}
          maxDate={maxDate}
          onChange={this.onDateChange}
        />
      </div>
    )
  }

  static propTypes = {
    className: string,
    date: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    cmpRef: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    readOnly: PropTypes.bool,
    screenReaderInputMessage: PropTypes.string,
    showClearDate: PropTypes.bool,
    withFullScreenPortal: PropTypes.bool,
  }
}

export default ASingleDatePicker
